<template>
  <div>
    <div class="row mb-3">
      <div class="col-7 d-flex">
        <i-input
          v-model="form.name"
          suffix="ios-search"
          :placeholder="$t(`shared.component.filter.search`)"
          :clearable="true"
          @keyup.native.enter="search"
          @on-clear="search"
        />
        <i-button
          class="dashboard-card__button offset-1 w-100"
          :to="{ name: 'db.database.index' }"
          type="primary"
          @click="$emit('close')"
        >
          {{ $t('shared.component.table.create_db') }}
        </i-button>
      </div>
      <div class="col-3 offset-2">
        <i-select
          v-if="groups.length"
          v-model="form.database_group_id"
          :filterable="true"
          :clearable="true"
          :transfer="true"
          @on-change="search"
        >
          <i-option
            key="without_groups_only"
            :label="$t('db.database.form.without_group')"
            value="without_groups_only"
          />
          <i-option v-for="g in groups" :key="g.id" :label="g.name" :value="g.id" />
        </i-select>
      </div>
    </div>

    <div class="alert alert-warning text-center">
      <p class="mb-0">{{ $t('shared.component.recipient_form.tab.include.required_format') }}</p>
    </div>

    <table-component :store="store" />
  </div>
</template>

<script>
  import TableComponent from './modal-recipient-input-databases-table';
  import { DataBaseGroupService } from '@db/services/GroupService';

  export default {
    components: {
      TableComponent
    },

    props: {
      store: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      groups: [],
      form: {
        name: '',
        database_group_id: ''
      }
    }),

    created() {
      this.$store.dispatch(`${this.store}/search`);
      DataBaseGroupService.getSelect().then((res) => (this.groups = res));
    },

    methods: {
      search: function () {
        const { name, database_group_id } = this.form;
        let without_groups_only = database_group_id === 'without_groups_only';
        const params = {
          name,
          database_group_id: without_groups_only ? '' : database_group_id,
          without_groups_only: without_groups_only ? 1 : 0
        };

        this.$store.dispatch(`${this.store}/search`, params);
      }
    }
  };
</script>
